/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react'
import '../style/storyv.css'

const StoryVideo = () => {
    return (
        <>
            <div className='container' style={{ textAlign: 'center', marginTop: '100px' }}>
                <h3 style={{color:'rgb(0, 65, 93)'}}>My life story, why I do what I do?</h3>
                <iframe id='ifV' style={{marginTop:'30px'}}
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/vx1GjX0wZ-4?start=36&autoplay=1"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </div>

        </>
    )
}

export default StoryVideo
